export default __webpack_public_path__ + "static/media/thumbnail-video-pixel-letalk.5d9c2378.jpg";